import PolicyLayout from "../components/PolicyLayout";

const RefundPolicyPage = () => {
  return (
    <PolicyLayout title="Refund & Cancellation Policy" lastUpdated="February 2026">
      <p className="text-base leading-relaxed mb-6">
        At <strong>theSnugglePrints</strong>, every product is custom-made for
        you — generated by AI from your pet's photo and printed on demand.
        Because each piece is one-of-a-kind and personalised, our refund
        policy is specifically designed to be fair to both our customers and
        our production process.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">1. Cancellations</h3>
      <p className="text-base leading-relaxed mb-6">
        Because we share a <strong>preview of your artwork</strong> with you
        before you pay, and every product is personalised and made-to-order,{" "}
        <strong>orders cannot be cancelled once payment is made</strong>. You
        always see and approve the design first — please review carefully
        before completing checkout.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">2. Refund Eligibility</h3>
      <p className="text-base leading-relaxed mb-4">
        You are eligible for a free replacement or a full refund in the
        following cases:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-6">
        <li>
          Your product arrived <strong>damaged</strong> or with a{" "}
          <strong>manufacturing defect</strong>
        </li>
        <li>
          You received the <strong>wrong item</strong> (different design or
          size)
        </li>
        <li>
          The printed product has a <strong>significant quality defect</strong>{" "}
          (e.g., print cut off, blurry ink, torn canvas, damaged binding)
        </li>
        <li>
          The product was <strong>lost in transit</strong> and confirmed as
          lost by the courier
        </li>
      </ul>

      <h3 className="text-2xl font-bold mt-10 mb-4">3. Non-Refundable Cases</h3>
      <p className="text-base leading-relaxed mb-4">
        Because our products are customised per order and previewed before
        payment, the following cases are <strong>NOT</strong> eligible for a
        refund:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-6">
        <li>Change of mind after approving the AI-generated preview</li>
        <li>Typos or spelling errors in the pet name you provided</li>
        <li>
          Minor aesthetic variation in the AI-generated illustration (AI
          output is probabilistic by nature — you always preview the result
          before paying)
        </li>
        <li>Incorrect shipping address provided by you at checkout</li>
        <li>Delays caused by the courier after dispatch from our facility</li>
        <li>
          Delays caused by the customer (e.g., late sharing of photos,
          descriptions, or draft approvals for Photo Books)
        </li>
      </ul>

      <h3 className="text-2xl font-bold mt-10 mb-4">4. How to Report an Issue</h3>
      <p className="text-base leading-relaxed mb-4">
        If your order qualifies, please email us within{" "}
        <strong>48 hours of delivery</strong> with:
      </p>
      <ul className="list-disc ml-6 space-y-2 mb-6">
        <li>Your order reference number</li>
        <li>Clear photos showing the defect or damage</li>
        <li>A brief description of the issue</li>
      </ul>
      <p className="text-base leading-relaxed mb-6">
        Email: <strong>contact@thesnuggleprints.com</strong>
        <br />
        Subject: <em>Refund Request — [ORDER REF]</em>
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">5. Replacements</h3>
      <p className="text-base leading-relaxed mb-6">
        Our default resolution for any eligible case (Section 2) is a{" "}
        <strong>free replacement</strong>. We will reprint and ship the product
        again at no extra cost to you. There is <strong>no return shipping
        required</strong> — please do not ship the defective item back unless
        we specifically ask you to.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">6. Refund Timeline</h3>
      <ul className="list-disc ml-6 space-y-2 mb-6">
        <li>
          We review and respond within <strong>2 business days</strong>.
        </li>
        <li>
          If a refund is approved (instead of a replacement), it will be issued
          to the <strong>original payment method</strong>.
        </li>
        <li>
          Refunds typically reflect in your account within{" "}
          <strong>5–10 business days</strong>, depending on your bank or card
          issuer.
        </li>
        <li>
          You will receive an email confirmation once the refund is initiated.
        </li>
      </ul>

      <h3 className="text-2xl font-bold mt-10 mb-4">7. International Orders</h3>
      <p className="text-base leading-relaxed mb-6">
        The same policy applies to international orders. Today, all payments
        — including international ones — are processed in INR via Razorpay,
        and refunds are issued back to the original payment method in INR.{" "}
        <strong>PayPal-based USD checkout is launching soon</strong>; once
        live, international refunds will be issued in USD via PayPal to the
        original payment method.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">8. Contact</h3>
      <p className="text-base leading-relaxed mb-6">
        For any refund or replacement query, reach us at:
        <br />
        Email: <strong>contact@thesnuggleprints.com</strong>
        <br />
        Hours: Mon–Sat, 10:00–19:00 IST
      </p>
    </PolicyLayout>
  );
};

export default RefundPolicyPage;
